import livecasino from '../assets/images/menu-icons/livecasino-icon.svg'
import sportsbook from '../assets/images/menu-icons/sportsbook-icon.svg'
import blastoff from '../assets/images/menu-icons/blastoff-icon.svg'
import election from '../assets/images/menu-icons/election-icon.svg'
import bannerСasino from '../assets/images/banners/sport-banner-casino.png'
import bannerExchange from '../assets/images/banners/sport-banner-exchange.png'
import bannerHorse from '../assets/images/banners/sport-banner-horse.svg'
import bannerGreyhound from '../assets/images/banners/sport-banner-greyhound.svg'



const leftSideMenuMapper = {
  'My Markets': {
    img: '',
  },

  Cricket: {
    id: 4,
    name: 'Cricket',
    img: 'ꀃ',
  },

  Football: {
    id: 1,
    name: 'Football',
    img: "ꀄ",
  },

  Tennis: {
    id: 2,
    name: 'Tennis',
    img: "ꀅ",
  },

  // virtual: {
  //   id: 'v9',
  //   name: 'Virtual',
  //   img: 'ꀃ',
  // },

  // ballByBall: {
  //   id: 'b9',
  //   name: 'Ball By Ball',
  //   img: 'ꀃ',
  // },

  Election: {
    id: 2378962,
    name: 'Election',
    img: election,
    isSvg: true,
  },

  'Indian Card Games': {
    id: 1444001,
    name: 'Indian Card Games',
    img: '',
    banner: bannerExchange,
    bannerClass: 'exchange',
    bannerLink: '/menu-event/1444001',
  },
  'Popular Games': {
    id: 1111111,
    name: 'Popular Games',
    img: '',
    banner: bannerExchange,
  },
  'Casino': {
    id: 1444000,
    name: 'Casino',
    img: livecasino,
    isSvg: true,
  },

  'Casino Live': {
    name: 'Casino',
    id: 77777,
    img: "",
    banner: bannerСasino,
    bannerClass: 'casino',
    bannerLink: '/casino_live/1444000',
  },

  'Horse Racing': {
    id: 7,
    name: 'Horse Racing',
    img: "ꀂ",
    banner: bannerHorse,
    bannerClass: 'greyhound',
    bannerLink: '/menu-event/7',
  },

  'Greyhound Racing': {
    id: 4339,
    name: 'Greyhound Racing',
    img: "ꀁ",
    banner: bannerGreyhound,
    bannerClass: 'horse',
    bannerLink: '/menu-event/4339',
  },

  Sportsbook: {
    id: 1444005,
    name: 'Sportsbook (80+)',
    img: sportsbook,
    isSvg: true,
  },

  'BlastOff': {
    name: 'Blastoff',
    id: 67722-2,
    img: blastoff,
    bannerLink: '/casino_live/67722-2/FAWK',
    isSvg: true
  },

  // Apni Taraf se Banaye huee.. 
  'Exchange Games': {
    id: 1234,                //radom num
    name: 'Exchange Games',
    img: '',
    banner: bannerExchange,
    bannerClass: 'exchange',
    bannerLink: '/menu-event/1234',
  },
  'casino Providers': {
    id: 99999,
    name: 'casino Providers',
    img: "",
    banner: bannerСasino,
    bannerClass: 'casino',
    bannerLink: '/casino_live/1444000',
  },
  'Continue to Play': {
    id: 1111111,
    name: 'Continue to Play',
    img: '',
    banner: bannerExchange,
  },
}

export default leftSideMenuMapper


export const validIDs = {
  Cricket: new Set([4, 'v9', 'b9']),
  Football: new Set([1]),
  Tennis: new Set([2]),
  Election: new Set([2378962]),
  'Indian Card Games': new Set([1444001]),
  'Popular Games': new Set([1111111]),
  'Casino': new Set([1444000]),
  'Casino Live': new Set([77777]),
  'Horse Racing': new Set([7]),
  'Greyhound Racing': new Set([4339]),
  Sportsbook: new Set([4339]),
  BlastOff: new Set([67722-2]),
  'Exchange Games': new Set([1234]),
  'casino Providers': new Set([99999]),
  'My Markets': new Set([])
};